'use client'

import type { SearchSuggestionsResultsProps } from '@maestro/commerce-blocks/components/search-bar/search.types'

import { useCallback, useEffect } from 'react'

import { useA11y } from '@maestro/core/a11y/a11y.context'
import { useEventBusContext } from '@maestro/core/event/event-bus.context'
import { EventType } from '@maestro/data-layer'

export const useSearchSuggestionsResults = ({
  removalMessage,
  handleSuggestionSelectAction,
}: Pick<
  SearchSuggestionsResultsProps,
  'removalMessage' | 'handleSuggestionSelectAction'
>) => {
  const { publish } = useEventBusContext()
  const { announce } = useA11y()

  useEffect(() => {
    announce(removalMessage)
  }, [announce, removalMessage])

  const handleClickSuggestion = useCallback(
    (query: string, url: string) => {
      publish(EventType.SEARCH_SUGGESTIONS_CLICKED, {
        searchSection: 'Autocomplete Suggestions',
        searchTerm: query,
        url: url,
      })
      handleSuggestionSelectAction(query)
    },
    [handleSuggestionSelectAction, publish]
  )

  return {
    handleClickSuggestion,
  }
}
